import { Tabs } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router";

import { hasView, useAuth } from "@/auth/auth-context";
import { PageHeader } from "@/components/ui/page";

type ContractsTab = "loans" | "services";

/**
 * Commercial paper hub: comodato and monitoring service stay separate
 * instruments (ADR-074 / ADR-077) but share one nav entry and tabbed lists.
 */
export function ContractsPage() {
  const { t } = useTranslation("pages");
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const canLoans = hasView(user, "LOAN_AGREEMENTS");
  const canServices = hasView(user, "SERVICE_AGREEMENTS");
  const activeTab: ContractsTab = location.pathname.includes("/contracts/services")
    ? "services"
    : "loans";

  return (
    <>
      <PageHeader title={t("contractsTitle")} description={t("contractsDescription")} />

      <Tabs
        value={activeTab}
        onChange={(value) => {
          if (value === "services") {
            void navigate("/contracts/services");
            return;
          }

          if (value === "loans") {
            void navigate("/contracts/loans");
          }
        }}
        mb="md"
      >
        <Tabs.List>
          {canLoans ? (
            <Tabs.Tab value="loans">{t("contractsTabLoans")}</Tabs.Tab>
          ) : null}
          {canServices ? (
            <Tabs.Tab value="services">{t("contractsTabServices")}</Tabs.Tab>
          ) : null}
        </Tabs.List>
      </Tabs>

      <Outlet />
    </>
  );
}

/** `/contracts` → first tab the membership can open. */
export function ContractsIndexRedirect() {
  const { user } = useAuth();

  if (hasView(user, "LOAN_AGREEMENTS")) {
    return <Navigate to="/contracts/loans" replace />;
  }

  if (hasView(user, "SERVICE_AGREEMENTS")) {
    return <Navigate to="/contracts/services" replace />;
  }

  return <Navigate to="/profile" replace />;
}
